module.exports = __webpack_public_path__ + "static/media/storeIcon.5c0ce9f4.svg";